export default __webpack_public_path__ + "static/media/services2.4a7a9f88.jpg";